import { SurveyData } from './types';

export const formatValue = (value: string | number) => {
  if (typeof value === 'number') {
    const roundedValue = value.toFixed(1);
    return { display: roundedValue, full: value };
  }
  return { display: value, full: value };
};

export const transformArray = (inputArray: string[]): string[][] => {
  const result: string[][] = [];
  let currentSurvey: string[] = [];

  for (const item of inputArray) {
    if (item.toString().startsWith('Survey')) {
      if (currentSurvey.length > 0) {
        result.push(currentSurvey);
      }
      currentSurvey = [item];
    } else {
      currentSurvey.push(item);
    }
  }

  if (currentSurvey.length > 0) {
    result.push(currentSurvey);
  }

  return result;
};

export const extractUniqueValues = (
  data: SurveyData,
): { [key: string]: string[][] } => {
  const result: { [key: string]: string[][] } = {};

  for (const survey in data) {
    const uniqueValuesArray: string[] = [];

    data[survey].forEach((entry) => {
      if (Array.isArray(entry) && entry.length > 0) {
        const firstArray = entry[0];
        if (Array.isArray(firstArray)) {
          firstArray.forEach((element, index) => {
            uniqueValuesArray[index] = element;
          });
        }
      }
    });

    result[survey] = uniqueValuesArray.map((set) => Array.from(set));
  }

  return result;
};

export const dropdownSettingsTitles = ['Region', 'Site', 'Plume', ''];

export const calculateCategoryIndex = (
  categories: number[],
  value: number,
): number => {
  let closestIndex: number = -1;
  let closestDistance: number = Infinity;

  for (let i = 0; i < categories.length; i++) {
    let distance: number = Math.abs(categories[i] - value);
    if (distance < closestDistance) {
      closestDistance = distance;
      closestIndex = i;
    }
  }

  return closestIndex;
};

export const extractNumber = (inputString: string) => {
  const regex = /(\d+(\.\d+)?)\s*(%|SCFH)/;
  const match = inputString.match(regex);

  if (match) {
    return parseFloat(match[1]);
  } else {
    throw new Error('Incorrect number');
  }
};

export const processHeaderTitle = (title: string) => {
  return title.toLowerCase().indexOf('emission') >= 0
    ? title + ', SCFH'
    : title;
};

export const sortKeys = <T>(obj: Record<string, T[]>): Record<string, T[]> => {
  const sortedKeys = Object.keys(obj).sort();

  return sortedKeys.reduce<Record<string, T[]>>((acc, key) => {
    acc[key] = obj[key];
    return acc;
  }, {});
};

type Row = Record<string, any>;

export const filterSupplementedColumns = (data: Row[]): Row[] => {
  if (data.length === 0) {
    throw new Error('Input data is empty.');
  }

  const headerRow = data[0];
  const dataRows = data.slice(1);

  const allKeys = Object.keys(headerRow);

  const keysToKeep = allKeys.filter((key, index) => {
    return (
      index < 2 ||
      headerRow[key].toString().toLowerCase().includes('supplemented')
    );
  });

  const filteredHeaderRow: Row = {};
  keysToKeep.forEach((key) => {
    filteredHeaderRow[key] = headerRow[key];
  });

  const filteredDataRows = dataRows.map((row) => {
    const filteredRow: Row = {};
    keysToKeep.forEach((key) => {
      filteredRow[key] = row[key];
    });
    return filteredRow;
  });

  return [filteredHeaderRow, ...filteredDataRows];
};
